import WithRender from "../../templates/layouts/layoutMatrix.html";

export default WithRender({
  computed: {}
});
